import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://firelady.org';
const DEFAULT_TITLE = "After the Fire™ | Faith-Based Women's Empowerment with Dr. Gee";
const DEFAULT_IMAGE = `${SITE}/brand/logo-flame.jpg`;

export const Seo = ({ title, description, path = '', image, noindex = false, jsonLd }) => {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | After the Fire™` : DEFAULT_TITLE;
  const img = image ? (image.startsWith('http') ? image : `${SITE}${image}`) : DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="After the Fire™" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
